import React, { useState } from 'react';
import { db } from '../firebase';
import { 
    collection, 
    addDoc, 
    serverTimestamp,
    doc,        
    updateDoc,  
    getDoc      
} from 'firebase/firestore';
import { FaStar } from 'react-icons/fa'; 
import { useTranslation } from 'react-i18next';

const StarRating = ({ rating, setRating, label }) => {
    return (
        <div style={{ marginBottom: '10px' }}>
            <label style={{ fontWeight: 'bold' }}>{label}:</label>
            <div>
                {[...Array(5)].map((_, index) => {
                    const ratingValue = index + 1;
                    return (
                        <FaStar
                            key={index}
                            color={ratingValue <= rating ? "#ffc107" : "#e4e5e9"}
                            size={25}
                            onClick={() => setRating(ratingValue)}
                            style={{ cursor: 'pointer', marginRight: '5px' }}
                        />
                    );
                })}
            </div>
        </div>
    );
};

const GuestFeedbackForm = ({ bookingKey }) => {
    const { t } = useTranslation();
    const [ratings, setRatings] = useState({
        stay: 0,
        cleaning: 0,
        staff: 0,
        comments: '',
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setRatings({ ...ratings, [e.target.name]: e.target.value });
    };

    const handleRatingChange = (name, value) => {
        setRatings({ ...ratings, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!bookingKey || ratings.stay === 0 || ratings.cleaning === 0 || ratings.staff === 0) {
            alert(t('feedback.err_incomplete'));
            return;
        }

        setLoading(true);

        try {
            const guestRef = doc(db, 'guests', bookingKey);
            const guestSnap = await getDoc(guestRef);

            if (!guestSnap.exists()) {
                alert(t('feedback.err_no_booking'));
                setLoading(false);
                return;
            }
            
            const hotelId = guestSnap.data().hotelId;
            
            await addDoc(collection(db, 'reviews'), {
                bookingKey: bookingKey,
                hotelId: hotelId,
                ...ratings,
                timestamp: serverTimestamp(),
            });

            await updateDoc(guestRef, {
                status: 'CHECKED_OUT_FINALIZED', 
                feedbackSubmittedAt: serverTimestamp(),
            });

            setSubmitted(true);
        } catch (error) {
            console.error("Feedback error:", error);
            alert(t('checkout.err_firebase'));
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <h2>{t('feedback.thanks_title')} 🙏</h2>
                <p>{t('feedback.thanks_msg')}</p>
            </div>
        );
    }

    return (
        <div style={{ maxWidth: '400px', margin: '30px auto', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <h2>{t('feedback.title')}</h2>
            <form onSubmit={handleSubmit}>
                <StarRating
                    label={`⭐ ${t('feedback.rate_stay')}`}
                    rating={ratings.stay}
                    setRating={(val) => handleRatingChange('stay', val)}
                />

                <StarRating
                    label={`🧹 ${t('feedback.rate_cleaning')}`}
                    rating={ratings.cleaning}
                    setRating={(val) => handleRatingChange('cleaning', val)}
                />

                <StarRating
                    label={`👥 ${t('feedback.rate_staff')}`}
                    rating={ratings.staff}
                    setRating={(val) => handleRatingChange('staff', val)}
                />

                <div style={{ marginTop: '20px' }}>
                    <label htmlFor="comments" style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
                        📝 {t('feedback.comments_label')}
                    </label>
                    <textarea
                        id="comments"
                        name="comments"
                        value={ratings.comments}
                        onChange={handleChange}
                        rows="4"
                        placeholder={t('feedback.comments_placeholder')}
                        style={{ width: '100%', padding: '10px', boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: '4px' }}
                    />
                </div>

                <button type="submit" disabled={loading} style={{ 
                    width: '100%', padding: '10px', marginTop: '20px', backgroundColor: '#28a745', 
                    color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' 
                }}>
                    {loading ? t('checker.searching') : t('feedback.btn_submit')}
                </button>
            </form>
        </div>
    );
};

export default GuestFeedbackForm;